import React from 'react';
import styles from './AccountNotFound.module.css';
import keycloak from '../../keycloak';

const AccountNotFound = () => {
  const dashboardRedirectUri = typeof window !== "undefined" ? `${window.location.origin}/` : undefined;

  const handleLogout = () => {
    keycloak.logout({ redirectUri: dashboardRedirectUri });
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.title}>Account not set up</div>
        <p className={styles.message}>
          You're signed in, but there's no account set up for you in the invoicing app yet.
          If you're expecting access, ask your manager to create your account.
        </p>
        <button type="button" className={styles.logoutButton} onClick={handleLogout}>
          Log out
        </button>
      </div>
    </div>
  );
};

export default AccountNotFound;
